import DataTable from "../../../components/data-table/data-table";
import { alertcaseColumns } from "../alertcases-columns";

interface IOpenActiveAlertCasesProps {
  onActionClick?: (action_key: string, rowId: string) => void;
  onBeforeRowClick?: (rowId: string) => Promise<boolean>;
}

const OpenActiveAlertCases = ({onActionClick, onBeforeRowClick}: IOpenActiveAlertCasesProps) => {
  return <div className="openActiveAlertCases">
    <DataTable
      style="compact"
      columns={alertcaseColumns}
      defaultSortDirection="desc"
      defaultSortCol="creation_date"
      dataUrl={{
        url: "alertcases",
        backend: "manager",
        queryString: "openactive=True"
      }}
      selectionMode="off"
      onActionClick={onActionClick}
      onBeforeRowClick={onBeforeRowClick}
    />
  </div>;
};

export default OpenActiveAlertCases;